<template>
  <div class="runners">
    <div class="runners__content">
      <responsive>
        <table class="table">
          <thead>
            <th id="ID" style="min-width: 90px">ID</th>
            <th id="RunnerName" style="min-width: 200px">Runner name</th>
            <th id="Location" style="min-width: 150px">Location</th>
            <th id="Gender" style="min-width: 80px">Gender</th>
            <th id="E-mail" style="min-width: 300px">E-mail</th>
            <th id="Facebook" style="min-width: 100px">Facebook</th>
            <th id="AccountCreate" style="min-width: 150px">Account Create</th>
            <th id="MembershipTrialStart" style="min-width: 180px">Membership trial start</th>
            <th id="MembershipTrialEnd" style="min-width: 180px">Membership trial end</th>
            <th id="Height" style="min-width: 95px">Height</th>
            <th id="Weight" style="min-width: 95px">Weight</th>
            <th id="ProfileText" style="min-width: 300px">Profile text</th>
            <th id="Website" style="min-width: 300px">Website</th>
            <th id="TotalCompletedRuns" style="min-width: 180px">Total Completed Runs</th>
            <th id="LastLiveRun" style="min-width: 150px">Last LiveRun</th>
            <th id="DaysSinceLastLiveRun" style="min-width: 200px">Days since last LiveRun</th>
            <th id="PromoCode" style="min-width: 150px">Promo code</th>
          </thead>

          <tbody>
            <tr v-for="(runner, index) in runners" :key="index">
              <td><a href= "javascript:void(0)" @click  = getRunnersData(runner.id) > {{runner.id }}</a></td>
              
              <td>{{ runner.runnerName || '-' }}</td>
              <td>{{ runner.location || '-' }}</td>
              <td class="center">{{ runner.gender || '-' }}</td>
              <td>{{ runner.email || '-' }}</td>
              <td>{{ runner.facebook ? 'Yes' : 'No' }}</td>
              <td>{{ runner.accountCreate || '-' }}</td>
              <td class="center">{{ runner.membershipStartDate || '-' }}</td>
              <td class="center">{{ runner.membershipEndDate || '-' }}</td>
              <td class="center">{{ runner.height || '-' }}</td>
              <td class="center">{{ runner.weight || '-' }}</td>
              <td>{{ unicodeToChar(runner.profileText) || '-' }}</td>
              <td>{{ runner.website || '-' }}</td>
              <td class="center">{{ runner.totalCompletedRuns || '0' }}</td>
              <td class="center">{{ runner.lastLiveRun || '-' }}</td>
              <td class="center">{{ runner.daysSinceLastClass || '0' }}</td>
              <td class="center">{{ runner.promoCode || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </responsive>

      <paginate
        :page-count="totalPages"
        :click-handler="handlePaginate"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :container-class="'pagination'"
        :page-class="'pagination__item'">
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import Responsive from '@/components/Responsive'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'AllRunners',
  computed: {
    ...mapGetters({
      runners: 'runners/allRunners',
      totalPages: 'runners/totalPages'
    }),
  },
  methods: {
    handlePaginate (page) {
      this.getAll(page - 1)
    },
    unicodeToChar(text) {
        if(text != null)
    return text.replace(/\\u[\dA-F]{4}/gi, 
            function (match) {
                return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
            })
    },
    getRunnersData(id){
          let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: id,
                          raceId: 2285
                    }
                    })
              window.open(route.href, '_blank')
    },
    ...mapActions({
      getAll: 'runners/getAllWithRunCompleted',
      clearAllRunners: 'runners/clearAllRunners'
    })
  },
  mounted () {
    this.getAll(0)
  },
  beforeDestroy () {
    this.clearAllRunners()
  },
  components: {
    Paginate,
    Responsive
  }
}
</script>

<style lang="stylus" scoped>
//   @import '../../components/Table/table.styl'
//   @import '../../components/Pagination/pagination.styl'

  .runners
    display inline
    flex-flow row wrap

    &__content
      background #fff
      box-shadow 0 2px 6px 0 rgba(0,0,0,0.2)
      max-width 100%
</style>



// WEBPACK FOOTER //
// AllWithRunCompleted.vue?7c1457fc